module.exports = __webpack_public_path__ + "static/media/stamp_18.fbffb834.png";